import PropTypes from 'prop-types';

// @mui
import { Box, Card, Link, MenuList, Paper, Popover, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
// components
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ButtonAction from 'src/components/Button.js/SaveButton';
import DeviceDetail from 'src/components/DrawerSidebar/DeviceDetail';
import ViewImageModal from 'src/components/modal/ViewImageModal';
import { glb_sv } from 'src/utils';
import imgDefault from '../../../image/default/groups.png';

// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    padding: '10px',
});

// ----------------------------------------------------------------------

ItemGroupDevice.propTypes = {
    product: PropTypes.object,
};

export default function ItemGroupDevice({
    setData,
    product,
}) {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [visibleImage, setVisibleImage] = useState(false);
    const [open, setOpen] = useState(false);
    // const navigate = useNavigate();
    const params = useParams();
    const renderProperty = (property) => {
        let str = '';
        if (property)
            for (let i = 0; i < property.length; i++) {
                if (property[i].checked)
                    if (i + 1 < property.length) {
                        str += glb_sv.convertMultipleLanguages(property[i].labelDisplay) + ', ';
                    } else {
                        str += glb_sv.convertMultipleLanguages(property[i].labelDisplay);
                    }
            }
        return (
            <>
                {/* {str}{' '} */}
                <span
                    onClick={handleOpen}
                    style={{
                        fontStyle: 'italic',
                        textDecoration: 'underline',
                        color: '#057a6b',
                        cursor: 'pointer',
                    }}
                >
                    {t('detail')}
                </span>
            </>
        );
    };
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    return (
        <Card>
            <ViewImageModal
                setVisible={setVisibleImage}
                visible={visibleImage}
                url={product?.pic_properties_device && `${glb_sv.urlGetProductImage(product?.pic_properties_device)}`}
                image_name={glb_sv.convertMultipleLanguages(product?.group_nm)}
            />
            <DeviceDetail device={product} open={visible} setOpen={setVisible} />

            <Box sx={{ pt: '100%', position: 'relative' }}>
                <StyledProductImg
                    onClick={() =>
                        // navigate(
                        //     url ? url + product.id : `/home/group-device/${params.idPermission}/devices/${product.id}`
                        // )
                        setData(product)
                    }
                    alt={glb_sv.convertMultipleLanguages(product?.group_nm)}
                    src={product?.pic_device ? `${glb_sv.urlGetProductImage(product?.pic_device)}` : imgDefault}
                />
            </Box>

            <Stack spacing={1} sx={{ p: 2 }}>
                <Link
                    color="primary"
                    underline="always"
                    sx={{ fontStyle: 'italic', cursor: 'pointer' }}
                    onClick={() => setData(product)}
                >
                    <Typography variant="subtitle1" noWrap>
                        {glb_sv.convertMultipleLanguages(product?.group_nm)}
                    </Typography>
                </Link>

                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Typography variant="subtitle1" sx={{ fontSize: '14px' }} noWrap>
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('code_group')}:
                        </Typography>
                        &nbsp;
                        {product?.group_cd}
                    </Typography>
                </Stack>

                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Typography variant="subtitle1" sx={{ fontSize: '14px' }}>
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('property')}:
                        </Typography>
                        &nbsp;
                        {renderProperty(product?.group_properties)}
                    </Typography>{' '}
                    <Popover
                        open={Boolean(open)}
                        anchorEl={open}
                        onClose={() => setOpen(false)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                mt: 1.5,
                                ml: 0.75,
                                width: 400,
                            },
                        }}
                    >
                        <Paper>
                            <MenuList>
                                {product?.group_properties?.length > 0 &&
                                    product?.group_properties.map((item, idx) => (
                                        <Typography
                                            padding={1}
                                            key={idx}
                                            sx={{
                                                fontSize: '16px',
                                                color: 'text.secondary',
                                                width: 'fit-content',
                                            }}
                                        >
                                            <Typography noWrap>
                                                {glb_sv.convertMultipleLanguages(item?.label)}:{' '}
                                            </Typography>
                                            <Typography
                                                paddingLeft={0.5}
                                                variant="body1"
                                                sx={{ color: 'text.primary' }}
                                                noWrap={false}
                                            >
                                                {item?.value?.length > 0 &&
                                                    item?.value.map((value, index) => {
                                                        let str = '';
                                                        index + 1 < item?.value?.length
                                                            ? (str += glb_sv.convertMultipleLanguages(value) + ', ')
                                                            : (str += glb_sv.convertMultipleLanguages(value));
                                                        return str;
                                                    })}
                                            </Typography>
                                        </Typography>
                                    ))}

                                {product?.pic_properties_device && (
                                    <Typography
                                        padding={1}
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                            width: 'fit-content',
                                        }}
                                    >
                                        <Typography noWrap>{t('img_properties')}</Typography>
                                        <Typography
                                            paddingLeft={0.5}
                                            variant="body1"
                                            sx={{ color: 'text.primary', width: '100%' }}
                                        >
                                            <img
                                                onClick={() => setVisibleImage(true)}
                                                src={
                                                    product?.pic_properties_device &&
                                                    `${glb_sv.urlGetProductImage(product?.pic_properties_device)}`
                                                }
                                                alt=""
                                            />
                                        </Typography>
                                    </Typography>
                                )}
                            </MenuList>
                        </Paper>
                    </Popover>
                </Stack>
            </Stack>
        </Card>
    );
}
